import FirstPageIcon from '@mui/icons-material/FirstPageRounded';
import logo from './logo.svg';
import StyledBox, { BackButton } from './styles';

export default function SideMenuHeader(props: {onClose: () => void;}) {
  const { onClose } = props;
  return (
    <StyledBox className="header">
      <img src={logo} alt="CogNeed logo" />
      <BackButton onClick={onClose}>
        <FirstPageIcon />
      </BackButton>
    </StyledBox>
  );
}
